import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export default function initSwiper() {
    document.addEventListener('DOMContentLoaded', function() {
        const activitiesSwiperEls = document.querySelectorAll('.activities-swiper');

        if (activitiesSwiperEls.length === 0) {
            return;
        }

        activitiesSwiperEls.forEach((swiperEl) => {
            // Find controls within the same container as this swiper
            const container = swiperEl.closest('.swiper-container-wrapper') || swiperEl.parentElement;
            const progressBar = container.querySelector('.swiper-progress-bar');
            const progressFill = container.querySelector('.swiper-progress-fill');
            const nextButton = container.querySelector('.swiper-button-next');
            const prevButton = container.querySelector('.swiper-button-prev');

            const activitiesSwiper = new Swiper(swiperEl, {
                modules: [Navigation, Autoplay],
                slidesPerView: 1.25,
                spaceBetween: 15,
				autoplay: false,
                // autoplay: {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    }
                },

                on: {
                    init: function() {
                        updateProgressBar(this);
                        checkSlideNavigation(this);
                    },
                    slideChange: function() {
                        updateProgressBar(this);
                        checkSlideNavigation(this);
                    }
                }
            });

            function updateProgressBar(swiper) {
                if (progressFill) {
                    const totalSlides = swiper.slides.length;
                    const slidesPerView = swiper.slidesPerViewDynamic();
                    const currentIndex = swiper.activeIndex;
                    const isDesktop = window.innerWidth >= 768;

                    // Calculate the maximum index where scrolling stops
                    // Desktop: stop before last 2 cards, Mobile: allow scrolling to last card
                    const stopOffset = isDesktop ? 2 : 0;
                    const maxScrollIndex = Math.max(0, totalSlides - slidesPerView - stopOffset);

                    // Calculate progress based on scroll position
                    const progress = maxScrollIndex > 0 ? (currentIndex / maxScrollIndex) * 100 : 0;
                    progressFill.style.width = Math.min(100, progress) + '%';
                }
            }

            function checkSlideNavigation(swiper) {
                const totalSlides = swiper.slides.length;
                const slidesPerView = swiper.slidesPerViewDynamic();
                const currentIndex = swiper.activeIndex;
                const isDesktop = window.innerWidth >= 768;

                // Desktop: stop before last 2 cards, Mobile: allow scrolling to last card
                const stopOffset = isDesktop ? 2 : 0;
                const maxIndex = Math.max(0, totalSlides - slidesPerView - stopOffset);

                // Disable next navigation if at or past the limit
                swiper.allowSlideNext = currentIndex < maxIndex;
            }

            // Make progress bar clickable and draggable
            if (progressBar) {
                let isDragging = false;
                let wasAutoplayPaused = false;

                function updateSlideFromPosition(clientX) {
                    const rect = progressBar.getBoundingClientRect();
                    const position = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
                    const totalSlides = activitiesSwiper.slides.length;
                    const slidesPerView = activitiesSwiper.slidesPerViewDynamic();
                    const isDesktop = window.innerWidth >= 768;
                    const stopOffset = isDesktop ? 2 : 0;
                    const maxScrollIndex = Math.max(0, totalSlides - slidesPerView - stopOffset);
                    const slideIndex = Math.round(position * maxScrollIndex);
                    activitiesSwiper.slideTo(slideIndex);
                }

                // Mouse events
                progressBar.addEventListener('mousedown', function(e) {
                    e.preventDefault();
                    isDragging = true;

                    // Pause autoplay while dragging
                    if (activitiesSwiper.autoplay.running) {
                        activitiesSwiper.autoplay.stop();
                        wasAutoplayPaused = true;
                    }

                    progressBar.classList.add('dragging');
                    updateSlideFromPosition(e.clientX);
                });

                document.addEventListener('mousemove', function(e) {
                    if (isDragging) {
                        e.preventDefault();
                        updateSlideFromPosition(e.clientX);
                    }
                });

                document.addEventListener('mouseup', function() {
                    if (isDragging) {
                        isDragging = false;
                        progressBar.classList.remove('dragging');

                        // Resume autoplay after a short delay
                        if (wasAutoplayPaused) {
                            setTimeout(() => {
                                activitiesSwiper.autoplay.start();
                                wasAutoplayPaused = false;
                            }, 1000);
                        }
                    }
                });

                // Touch events for mobile
                progressBar.addEventListener('touchstart', function(e) {
                    e.preventDefault();
                    isDragging = true;

                    if (activitiesSwiper.autoplay.running) {
                        activitiesSwiper.autoplay.stop();
                        wasAutoplayPaused = true;
                    }

                    progressBar.classList.add('dragging');
                    const touch = e.touches[0];
                    updateSlideFromPosition(touch.clientX);
                }, { passive: false });

                document.addEventListener('touchmove', function(e) {
                    if (isDragging) {
                        e.preventDefault();
                        const touch = e.touches[0];
                        updateSlideFromPosition(touch.clientX);
                    }
                }, { passive: false });

                document.addEventListener('touchend', function() {
                    if (isDragging) {
                        isDragging = false;
                        progressBar.classList.remove('dragging');

                        if (wasAutoplayPaused) {
                            setTimeout(() => {
                                activitiesSwiper.autoplay.start();
                                wasAutoplayPaused = false;
                            }, 1000);
                        }
                    }
                });

                // Simple click (without drag)
                progressBar.addEventListener('click', function(e) {
                    if (!isDragging) {
                        updateSlideFromPosition(e.clientX);
                    }
                });
            }
        }); // End forEach
    });
}
